import { UserOutlined } from '@ant-design/icons'
import UserIcon from '@assets/CustomIcons/user_edited.svg'
import BBDLogo from '@assets/Logos/bbd-logo.svg'
import { Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import dayjs from 'dayjs'
import moment from 'moment'
import * as React from 'react'

// Generic interface that works with both SurchargeRate and Rate
interface RateWithUpdateInfo {
  effective_from: string
  created_by?: string
  created_on?: string
  updated_by?: string | string[]
  updated_on?: string
  updated_date?: string
  created_date?: string
  [key: string]: any
}

interface RateUpdateInfoProps {
  rate: RateWithUpdateInfo
}

const iconStyles = {
  width: 24,
  height: 24,
}

// Helper function to format date in compact format (DD/MM, H:MM)
const formatCompactDate = (date: string | Date | undefined): string => {
  if (!date) return ''

  const dateObj = moment(date)
  if (!dateObj.isValid()) return ''

  return dateObj.format('DD/MM, H:mm')
}

export function RateUpdateInfo({ rate }: RateUpdateInfoProps) {
  const createdBy = rate.created_by || 'System'
  const updatedBy = rate.updated_by || 'System'
  const createdOn = rate.created_on || rate.created_date || rate.effective_from
  const updatedOn = rate.updated_on || rate.updated_date || ''

  // Only show updated by if it's different from created by or at a different time
  const hasUpdateInfo = !!updatedBy && !!updatedOn && (updatedBy !== createdBy || updatedOn !== createdOn)

  return (
    <div style={{ minWidth: 300 }}>
      {/* Always show creator info */}
      <Horizontal style={{ marginBottom: 8 }}>
        <Vertical flex={2} gap='4px'>
          <Texto category='label' weight='600' className='popover-subtitle'>
            Created By
          </Texto>
          <Horizontal alignItems='center'>
            <img src={UserIcon} style={iconStyles} alt='User Icon' />
            <Texto category='p1' className='popover-status-text pl-2'>
              {createdBy}
            </Texto>
          </Horizontal>
        </Vertical>
        <Vertical style={{ overflow: 'visible' }} gap='4px' flex={1} alignItems='flex-end'>
          <Texto className='popover-subtitle' category='label' weight='600'>
            At
          </Texto>
          <Texto style={{ whiteSpace: 'nowrap' }} category='p1'>
            {formatters.WEEKDAY_MONTH_DATE_TIME(moment(createdOn))}
          </Texto>
        </Vertical>
      </Horizontal>

      {/* Show update info only if it's different from created by */}
      {hasUpdateInfo && (
        <Horizontal>
          <Vertical gap='4px' flex={2} style={{ overflow: 'visible' }}>
            <Texto category='label' weight='600' className='popover-subtitle'>
              Last Updated By
            </Texto>
            <Horizontal alignItems='center'>
              <img src={UserIcon} style={iconStyles} alt='User Icon' />
              <Texto category='p1' className='popover-status-text pl-2'>
                {updatedBy}
              </Texto>
            </Horizontal>
          </Vertical>
          <Vertical gap='4px' flex={1} alignItems='flex-end' style={{ overflow: 'visible' }}>
            <Texto className='popover-subtitle' category='label' weight='600'>
              At
            </Texto>
            <Texto style={{ whiteSpace: 'nowrap' }} category='p1'>
              {formatters.WEEKDAY_MONTH_DATE_TIME(moment(updatedOn))}
            </Texto>
          </Vertical>
        </Horizontal>
      )}
    </div>
  )
}
